import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

import {
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TableFooter,
  Autocomplete, Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import EditIcon from "@mui/icons-material/EditSquare";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from '@mui/icons-material/Delete';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Serverurl from "./Apiurl";

class Materialprocrumentpage extends Component {

  constructor(props) {
    super(props);

    this.state = {

      fromDate: dayjs().startOf("month"),
      toDate: dayjs(),

      materialId: "",projectarrauto: [],
  selectedProject: null,
      selectedMaterial: null,
      materialarrauto: [],

      vendorId: "",
      selectedVendor: null,
      vendorarrauto: [],

      projectId: "",
      selectedProject: null,
      projectarrauto: [],

      categoryId: "",
      selectedCategory: null,

      page: 0,
      rowsPerPage: 50,

      totalRecords: 0,
      totalAmount: 0,

      reportData: [],

      loading: false
    };
  }


  componentWillMount() {
if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
	let strname="Material Procurements";   
			 this.props.parentsCallback(
           strname
        );
    document.title = "VR Builders - Materialprocrumentpage";

   

    this.apicall(
      this.state.page,
      this.state.rowsPerPage
    );
  }

onloadProjectBind = (event) => {
axios.get(
  Serverurl +
    "ajaxprojects.php" +
    "?action=getallprojectautoextender" +
    "&projectname=" +
    encodeURIComponent(event.target.value)
)
    .then((resp) => {
      let strCust = [];
      (resp.data || []).forEach((row) => {
        const item = {
          title: row.pj_projectname,
          pj_id: row.pj_id,
          rowindex: row.rowindex
        };
        const found = strCust.some(
          (el) => el.pj_id === row.pj_id
        );
        if (!found) {
          strCust.push(item);
        }
      });
      this.setState({
        projectarray: resp.data || [],
        projectarrauto: strCust
      });
    });
};
onProjectChange = (event, value) => {
  this.setState({
    selectedProject: value,
    projectId: value ? value.pj_id : ""
  });
};

  onloadMaterialBind = (event) => {

    const materialName =
      event?.target?.value?.trim() || "";

    if (!materialName) {

      this.setState({
        materialarrauto: []
      });

      return;
    }

    axios.get(
        Serverurl +"ajaxmaterialprocurement.php",
        {
          params: {
            action: "materialprocautoextender",
            wc_name: materialName
          }
        }
      )
      .then((res) => {

        console.log(
          "Material autocomplete response:",
          res.data
        );

        const data =
          Array.isArray(res.data)
            ? res.data
            : [];

        const list =
          data.map((r) => ({
            title:r.wc_categoryname || "",
            wc_id:r.wc_id
          }));

        this.setState({
          materialarrauto: list
        });

      })
      .catch((error) => {
	  })

        this.setState({
          materialarrauto: []
        });

  };
  
  
  
	onloadVenderBind = (event) => {

	  const venderName =
		event?.target?.value?.trim() || "";

	  if (!venderName) {
		this.setState({
		  vendorarrauto: []
		});
		return;
	  }

	  axios.get(
		Serverurl + "ajaxtransactions.php",
		{
		  params: {
			action: "vendortypeautoextender",
			vendername: venderName,vm_type:"2",
		  }
		}
	  )
	  .then((res) => {

		console.log("Vendor response:", res.data);

		const data =
		  Array.isArray(res.data)
			? res.data
			: [];

		const list = data.map((r) => ({
		  title: r.vm_vendorname || "",
		  vm_se_id: r.vm_se_id,
		  vm_id: r.vm_id
		}));

		this.setState({
		  vendorarrauto: list
		});

	  })
	  .catch((error) => {

	  })

		this.setState({
		  vendorarrauto: []
		});
	};

  onMaterialChange = (
    event,
    value
  ) => {

    this.setState({
      selectedMaterial: value,
      materialId:value? value.wc_id: ""
    });

  };
  
  onVenderChange = (event, value) => {

  this.setState({
    selectedVendor: value,
    vendorId: value ? value.vm_id : ""
  });

};

  apicall = (page,rowsPerPage) => {

    this.setState({
      loading: true
    });

    axios.get(Serverurl +"ajaxmaterialprocurement.php",
        {
          params: {
            action:"getdatafordisplay",
			mp_wc_id: this.state.materialId,
			mp_vm_id: this.state.vendorId,
            mp_pj_id:this.state.projectId ,
            from_date:this.state.fromDate? this.state.fromDate.format("YYYY-MM-DD"): "",
			  to_date:this.state.toDate? this.state.toDate.format("YYYY-MM-DD"): "",
            index:page,
            maxrecrd:rowsPerPage,
            orderby:"mp_id DESC"
          }
        }
      )
      .then((res) => {

        const data =
          Array.isArray(res.data)
            ? res.data
            : [];

        let totalAmount = 0;

        data.forEach(
          (item) => {

            totalAmount +=
              Number(
                item.mp_amount || 0
              );

          }
        );

        this.setState({
          reportData:data,
          totalRecords:data.length > 0? parseInt(data[0].count || 0,10): 0,
          totalAmount:totalAmount,
          loading:false
        });

      })
      .catch((error) => {
	  } );

        this.setState({
          reportData:[],
          totalRecords:0,
          totalAmount:0,
          loading:false

        });

  };


  handleSearch = (event) => {

    if (event) {
      event.preventDefault();
    }
	
	console.log("Selected vendor:", this.state.selectedVendor);
    console.log("Vendor ID:", this.state.vendorId);
    this.setState(
      {
        page: 0
      },
      () => {

        this.apicall(
          0,
          this.state.rowsPerPage
        );

      }
    );

  };


  handlePageChange = (event,newPage) => {

    this.setState(
      {
        page:
          newPage
      },
      () => {

        this.apicall(
          newPage,
          this.state.rowsPerPage
        );

      }
    );

  };


  handleRowsChange = (event) => {


 this.setState(
    {
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0
    },
    () =>   this.apicall());
 

  };

Materialdelete(mpid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('mp_id',mpid)
	 	   
formData.append('userid',localStorage.getItem("VRuserid"))	
	
	
	 axios.post(Serverurl+"ajaxmaterialprocurement.php", formData, {
        }).then(res => {
    
          
   
 
this.apicall(); 
  
    
            });
 }
      }

  downloadFile = (file) => {
    if (!file) {
      return;
    }
    window.open(Serverurl +"uploads/" + file,"_blank");
  };
handleNumericChange = (field, e) => {
  const value = e.target.value;
  if (/^\d*\.?\d*$/.test(value)) {
    this.setState({ [field]: value });
  }
};
editRecord = (row) => {
  this.setState({
    mp_id: row.mp_id,
    mp_amount: row.mp_amount, // backend field
    openEdit: true
  });
};
handleClose = () => {
  this.setState({
    openEdit: false,
    mp_id: 0,
    mp_amount: ""
  });
};

updateAmount = () => {
  let formData = new FormData();
  formData.append("action", "materialpurchasereportupdateamount");
  formData.append("mp_id", this.state.mp_id);
  formData.append("mp_amount", this.state.mp_amount);
  formData.append("userid",localStorage.getItem("VRuserid"));
  axios
    .post(
      Serverurl + "ajaxmaterialprocurement.php",
      formData
    )
    .then(() => {
      this.setState({ openEdit: false });
     this.apicall(); 
    });
};
  render() {

    return (

      <React.Fragment>

        <div className="searchmaster">

          <ul>


            <li>

              <p>
               From Date
              </p>

              <p>

                <LocalizationProvider
                  dateAdapter={
                    AdapterDayjs
                  }
                >

                  <DatePicker
                    disableFuture
                    format="DD/MM/YYYY"

                    value={
                      this.state.fromDate
                    }

                    onChange={(
                      value
                    ) =>
                      this.setState({fromDate:value})
                    }

                    slotProps={{
                      textField: {
                        size:"small",
                        fullWidth:true
                      }
                    }}
                  />

                </LocalizationProvider>

              </p>

            </li>
			<li>

              <p>
               To Date
              </p>

              <p>

                <LocalizationProvider
                  dateAdapter={
                    AdapterDayjs
                  }
                >

                  <DatePicker
                    disableFuture
                    format="DD/MM/YYYY"

                    value={
                      this.state.toDate
                    }

                    onChange={(
                      value
                    ) =>
                      this.setState({toDate:value})
                    }

                    slotProps={{
                      textField: {
                        size:"small",
                        fullWidth:true
                      }
                    }}
                  />

                </LocalizationProvider>

              </p>

            </li>

 <li>
            <p  >Project</p>
  <p  >
            <Autocomplete className="inputcntlparent"
              options={this.state.projectarrauto}
              value={this.state.selectedProject}
              onChange={this.onProjectChange}
              getOptionLabel={(option) => option.title || ""}
              renderInput={(params) => (
                <TextField
                  {...params}
                  size="small"
                  placeholder="Search Project"
                  onChange={this.onloadProjectBind}
                />
              )}
              renderOption={(props, option) => (
                <li {...props}>{option.title}</li>
              )}
              fullWidth
            />
          </p></li>
            <li>

              <p>
                Material
              </p>

              <p>

                <Autocomplete
                  className={"inputcntlparent"}
                  options={this.state.materialarrauto}
                  value={this.state.selectedMaterial}
                  onChange={this.onMaterialChange}
                  getOptionLabel={(option) =>option?.title}
                  isOptionEqualToValue={(option,value) =>option?.wc_id ===value?.wc_id
                  }

                  renderInput={(
                    params
                  ) => (

                    <TextField
                      {...params}
                      size="small"
                      fullWidth
                      placeholder="Select Material"

                      onChange={this.onloadMaterialBind}
                    />

                  )}

                />

              </p>

            </li>     


			<li>

              <p>
                Vendor
              </p>

              <p>
				<Autocomplete
				  className="inputcntlparent"
				  options={this.state.vendorarrauto}
				  value={this.state.selectedVendor}
				  onChange={this.onVenderChange}
				  getOptionLabel={(option) => option?.title || ""}
				  isOptionEqualToValue={(option, value) =>
					option?.vm_id === value?.vm_id
				  }
				  renderInput={(params) => (
					<TextField
					  {...params}
					  size="small"
					  fullWidth
					  placeholder="Select Vendor"
					  onChange={this.onloadVenderBind}
					/>
				  )}
				/>
              </p>

            </li>     


            <li>

              <p>

                <Button
                  variant="contained"
                  className="exportbtn"

                  onClick={
                    this.handleSearch
                  }

                  endIcon={
                    <SearchIcon />
                  }
                >
                  Search
                </Button>


                <Link to="/Project-material-entry">

                  <Button
                    variant="contained"

                    sx={{
                      marginLeft:
                        "10px"
                    }}

                    endIcon={
                      <AddIcon />
                    }
                  >
                    New
                  </Button>

                </Link>

              </p>

            </li>

          </ul>

        </div>


        <TableContainer
          sx={{
            mt: 3
          }}
        >

          <Table>

            <TableHead>

              <TableRow>
			  
			  <TableCell>
                  Date
                </TableCell>
 <TableCell>
                  Projects
                </TableCell>
                <TableCell>
                  Material
                </TableCell>

                <TableCell>
                  Vendor
                </TableCell>

                <TableCell>
                  Quantity
                </TableCell>

                 <TableCell>
                  Amount
                </TableCell>


                <TableCell>
                  Remarks
                </TableCell>

                <TableCell>
                  Bill
                </TableCell>

                <TableCell>
                  Image
                </TableCell>

                <TableCell>
                </TableCell>

              </TableRow>

            </TableHead>


            <TableBody>

              {this.state
                .reportData
                .map(
                  (
                    r,
                    index
                  ) => (

                    <TableRow key={r.mp_id ||index}>


<TableCell>

                        {
						r.mp_date
                          ? dayjs(
                              r.mp_date
                            ).format(
                              "DD/MM/YYYY"
                            )
                          : ""}

                      </TableCell>
<TableCell>

                        {r.pj_projectname}

                      </TableCell>
                      <TableCell>

                        {r.wc_categoryname}

                      </TableCell>


                      <TableCell>

                        {r.vm_vendorname}

                      </TableCell>


                      <TableCell>

                        {r.mp_quantity}   {r.unit_name}

                      </TableCell>

   <TableCell>

                        Rs.   {parseFloat(r.mp_amount  ).toFixed(2)}

                      </TableCell>
					

                      <TableCell>

                        {r.mp_remarks }

                      </TableCell>


                      <TableCell>

                        {
                          r.mp_bill
                            ? (

                              <Button
                                variant="contained"
                                size="small"

                                onClick={() =>
                                  this.downloadFile(
                                    r.mp_bill
                                  )
                                }
                              >

                                <FileDownloadIcon />

                              </Button>

                            )
                            : (

                              "No Bill"

                            )
                        }

                      </TableCell>


                      <TableCell>

                        {
                          r.mp_image
                            ? (

                              <Button
                                variant="contained"
                                size="small"

                                onClick={() =>
                                  this.downloadFile(
                                    r.mp_image
                                  )
                                }
                              >

                                <FileDownloadIcon />

                              </Button>

                            )
                            : (

                              "No Image"

                            )
                        }

                      </TableCell>


                      <TableCell>
					  {r.pj_isactive==="0" &&(   <React.Fragment>
                        <Link
                          to={"/Project-material-entry?mp_id=" +r.mp_id}
                        >

                          <Button
                            variant="contained"
                            className="editbtn"

                            endIcon={
                              <EditIcon />
                            }
                          />

                        </Link> <Button variant="contained" className="deletebtn" onClick={()=>{this.Materialdelete(r.mp_id)}} endIcon={<DeleteIcon />}>

					  </Button>  </React.Fragment>)} <Button
                    variant="contained"
                    size="small"
                    onClick={() => this.editRecord(r)}
                  >
                    Edit <CurrencyRupeeIcon/>
                  </Button>
                      </TableCell>

                    </TableRow>

                  )
                )}

              {
                this.state
                  .reportData
                  .length === 0 &&
                !this.state
                  .loading && (

                  <TableRow>

                    <TableCell
                      colSpan={9}
                      align="center"
                    >
                      No Records
                    </TableCell>

                  </TableRow>

                )
              }

              



             

            </TableBody>


            

          </Table>


          {/* PAGINATION */}

         <TablePagination
		  rowsPerPageOptions={[50, 100, 150, 200, 250]}  
          component="div"
          count={this.state.totalRecords}
          page={this.state.page}
          onPageChange={this.handlePageChange}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.handleRowsChange}
		     
        />

        </TableContainer>


<Dialog
          open={this.state.openEdit}
          onClose={this.handleClose}
        >
          <DialogTitle>
            Material Procurement
          </DialogTitle>

          <DialogContent>
            <div style={{ marginTop: "10px" }}>
              <p
                style={{
                  marginBottom: "5px",
                  color: "#666"
                }}
              >
                Amount
              </p>

              <TextField
                fullWidth
                size="small"
                value={this.state.mp_amount}
                onChange={(e) =>
                  this.handleNumericChange(
                    "mp_amount",
                    e
                  )
                }
				
			  slotProps={{
                         htmlInput: {
                         maxLength:8,
                         tabIndex:1
                   }
                }}

              />
            </div>
          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleClose}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={this.updateAmount}
            >
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

export default Materialprocrumentpage;
